import { StreamingProtocol, PlaybackType } from "@sky-uk-ott/core-video-sdk-js";
import { getStreamFormat } from "./components/CoreVideoPlayer/generateSessionConfig/browserConfig.js";
const initializationOptions = {
  appBrand: "",
  appName: ""
};
const TestPresetTag = Symbol("TestPreset");
const testPreset = {
  [TestPresetTag]: true,
  initializationOptions,
  streamConfig: {
    [TestPresetTag]: true,
    type: PlaybackType.Live,
    manifests: ["https://dash.akamaized.net/dash264/TestCases/1b/qualcomm/1/MultiRatePatched.mpd"],
    protocol: getStreamFormat() === "dash" ? StreamingProtocol.DASH : StreamingProtocol.HLS,
    autoplay: false,
    adInstructions: {
      dai_MidRollEnabled: "false",
      dai_PreRollEnabled: "false"
    }
  }
};
export {
  TestPresetTag,
  testPreset };
//# sourceMappingURL=dist/testStreamPreset.js.map